import { render, staticRenderFns } from "./IncidentTab.vue?vue&type=template&id=32a31072"
import script from "./IncidentTab.js?vue&type=script&lang=js&external"
export * from "./IncidentTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports